export default "__VITE_ASSET__C1GaEF72__"